module.exports = [
    '$window',
    '$q',
    '$cookies',
    '$location',
    '$translate',
    '$translatePartialLoader',
    'config',
    'countryDataService',
    'dataContext',
    'identity',
    'language',
    'preferenceService',
    'applicationStateService',
    'favoritesService',
    'notificationsService',
    'messageModal',
    preloaderService
];


function preloaderService(
    $window,
    $q,
    $cookies,
    $location,
    $translate,
    $translatePartialLoader,
    config,
    countryDataService,
    context,
    identityService,
    languageService,
    preferenceService,
    state,
    favoritesService,
    notifications,
    messageModal
) {
    var service = {
        init: init,
        run: runWhenAuthenticated,
        languageChanged: languageChanged,
        identity: identityService,
        status: {
            isDone: true
        }
    };

    function init() {
        return identityService
            .init()
            .then(function (isAuthenticated) {
                if (isAuthenticated) {
                    return runWhenAuthenticated();
                }
            });
    }

    function languageChanged() {
        countryDataService.init();
    }

    function loadTranslations() {
        $translatePartialLoader.addPart('account');
        $translatePartialLoader.addPart('atr');
        $translatePartialLoader.addPart('bti');
        $translatePartialLoader.addPart('case-law');
        $translatePartialLoader.addPart('classification-regulation');
        $translatePartialLoader.addPart('compliance');
        $translatePartialLoader.addPart('conclusion');
        $translatePartialLoader.addPart('correlation-table');
        $translatePartialLoader.addPart('cross');
        $translatePartialLoader.addPart('customs-office');
        $translatePartialLoader.addPart('customs-value');
        $translatePartialLoader.addPart('customs-value-check');
        $translatePartialLoader.addPart('dashboard');
        $translatePartialLoader.addPart('documentation');
        $translatePartialLoader.addPart('ecics');
        $translatePartialLoader.addPart('exchange-rates');
        $translatePartialLoader.addPart('ezt');
        $translatePartialLoader.addPart('goods');
        $translatePartialLoader.addPart('main-menu');
        $translatePartialLoader.addPart('news');
        $translatePartialLoader.addPart('nomenclature');
        $translatePartialLoader.addPart('quota');
        $translatePartialLoader.addPart('referenceprices');
        $translatePartialLoader.addPart('regulation');
        $translatePartialLoader.addPart('search');
        $translatePartialLoader.addPart('shared-messages');
        $translatePartialLoader.addPart('shared-ui');
        $translatePartialLoader.addPart('sort-options');
        $translatePartialLoader.addPart('status');
        $translatePartialLoader.addPart('tares');
        $translatePartialLoader.addPart('taric');
        $translatePartialLoader.addPart('trade-statistics');
        $translatePartialLoader.addPart('validate-business-info');
        $translatePartialLoader.addPart('validation-errors');
        return $translate.refresh();
    }

    function loadPermissions() {
        return context
            .get(config.apiHosts.generic + '/me/permission')
            .then(function (data) {
                identityService.permissions = [];
                var hasPermissions = false;
                for (var prop in data) {
                    hasPermissions = true;
                    identityService.permissions = identityService.permissions.concat(data[prop]);
                }
                if (!hasPermissions) {
                    $cookies.remove('authToken');
                    $window.location.reload();
                }
            })
            .catch(function () {
                $cookies.remove('authToken');
                $window.location.reload();
            });
    }

    function runWhenAuthenticated() {
        service.status.isDone = false;
        return loadPermissions()
            .then(function () { return preferenceService.init(); })
            .then(function () { return configureServicesBasedOnPreferences() })
            .then(function () {
                return countryDataService.init()
                    .catch(function (error) {
                        if (state.filter.referenceCountry === 'FR') {
                            
                            console.error("Failed to initialize French country data. Falling back to EU.", error);
                            var title = "Error loading French trade tariff";
                            var message = "There was an error loading the French trade tariff. Loading EU trade tariff instead...";
                            var modalRef = messageModal.show(title, message);
                            window.setTimeout(function () {
                                modalRef.dismiss();
                                state.filter.referenceCountry = 'EU';
                                return preferenceService.setReferenceCountry('EU').then(() =>{
                                    $window.location.href = '/#!/';
                                    $window.location.reload();
    
                                    return common.$q.reject(error);
                                });
                            }, 5000);
                            

                        }
                        else {
                            // For other reference countries, this is still a real preload failure
                            throw error;
                        }
                    });
            })
            .then(function () { return loadSearchCountryPref(); })
            .then(function () { return loadFranceAreaOfApplicationPref(); })
            .then(function () { return favoritesService.init(); })
            .then(loadTranslations)
            .then(function () {
                service.status.isDone = true;
                notifications.subscribe("language_changed", languageChanged);
            })
            ;
    }

    function loadSearchCountryPref() {
        var deferred = $q.defer();
        var searchCountryPref = preferenceService.get('searchCountry', 'search');
        if (searchCountryPref) {
            var countryCode = searchCountryPref.value.split(',')[0];
            var countryName = searchCountryPref.value.split(',')[1];
            var searchCountryIsValidForReferenceCountry = _.some(countryDataService.ergaOmnesCountries, function (countryData) {
                return countryData.code === countryCode;
            });
            if (searchCountryIsValidForReferenceCountry) {
                state.filter.countryCode = countryCode;
                state.filter.countryName = countryName;
                state.remember.country = true;
            }
            else {
                preferenceService.remove(searchCountryPref);
            }
        }
        deferred.resolve();
        return $q.promise;
    }

    function loadFranceAreaOfApplicationPref() {
        var deferred = $q.defer();
        var pref = preferenceService.get('franceAreaOfApplication', 'measuresFilter');
        if (pref && state.filter.referenceCountry === 'FR') {
            state.filter.franceAreaOfApplication = pref.value;
            state.remember.franceAreaOfApplication = true;
        }
        deferred.resolve();
        return $q.promise;
    }

    function configureServicesBasedOnPreferences() {
        var deferred = $q.defer();
        if (preferenceService.get('uccModeEnabled', 'settings') !== null) {
            state.uccModeEnabled = preferenceService.get('uccModeEnabled', 'settings').value;
        }
        var referenceCountryPref = preferenceService.get('referenceCountry', 'search');
        if (referenceCountryPref) {
            state.filter.referenceCountry = referenceCountryPref.value;
            config.currentApi = 'dtv';
        }

        if (preferenceService.get('movement') === null) {
            preferenceService.add({
                name: 'movement',
                category: 'user_preferences',
                value: 'import',
                valueType: 'stringValue'
            });
            state.filter.movement = 'import';
        }
        else {
            state.filter.movement = preferenceService.get('movement').movement;
        }

        if (preferenceService.get('language', 'website') !== null) {
            languageService.set(preferenceService.get('language', 'website').value, false).then(function () {
                deferred.resolve();
            });
        }
        else {
            deferred.resolve();
        }
        return deferred.promise;
    }



    return service;
}